/**
 * Onboarding тур - первое знакомство пользователя с системой.
 * Запускается автоматически при первом входе.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'onboarding',
  name: 'help.tours.onboarding.name',
  description: 'help.tours.onboarding.description',

  // Настройки драйвера для onboarding
  options: {
    showProgress: true,
    allowClose: true,
    overlayClickNext: false,
    stagePadding: 15,
    stageRadius: 12,
  },

  steps: [
    // Шаг 1: Приветствие (без элемента - по центру экрана)
    {
      titleKey: 'help.tours.onboarding.welcome.title',
      descriptionKey: 'help.tours.onboarding.welcome.description',
      element: '.brand-block',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 2: Главное меню (только desktop). Якорь data-tour ставит App.vue на ту
    // навигацию, которая видна в текущем режиме: верхнюю или боковую колонку.
    {
      element: '[data-tour="main-nav"]',
      titleKey: 'help.tours.onboarding.navigation.title',
      descriptionKey: 'help.tours.onboarding.navigation.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 3: Меню пользователя з розгортанням dropdown
    {
      element: '.user-menu',
      titleKey: 'help.tours.onboarding.userMenu.title',
      descriptionKey: 'help.tours.onboarding.userMenu.description',
      side: 'bottom',
      align: 'end',
      // Розгортаємо меню користувача перед показом
      expandSelector: '.user-menu__trigger',
    },
    // Шаг 4: Уведомления
    {
      element: '.notification-bell:not(.notification-bell--mobile)',
      titleKey: 'help.tours.onboarding.notifications.title',
      descriptionKey: 'help.tours.onboarding.notifications.description',
      side: 'bottom',
      align: 'end',
    },
  ],
}
